export const calculateEstimatedWeightedTotal = orders => {
  const totalOrders = orders.reduce((total, current) => total + current.amount * current.price, 0);
  const totalAmounts = orders.reduce((total, current) => total + current.amount, 0);

  return totalOrders / totalAmounts || 0;
};
